import React, { useMemo, memo, useState, useCallback } from "react";
import { graphql } from "gatsby";
import Section from "../components/section";
import ThreeJsComponent from "../3D/app";
import LandingNavigation from "../components/landingNavigation";
import Loader from "../components/loader";
import GlobalStyle from "../styles/globalStyles";
import { IndexWrapper } from "../styles/components/landing";

const MemoizedThreeJsComponent = memo(ThreeJsComponent);

const IndexPage = ({ data }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const customTemplateId =
    data?.allDatoCmsBespokeStory?.edges[0]?.node?.customTemplateId;
  const storyContent = data?.allDatoCmsBespokeStory?.edges[0]?.node?.content;

  const id = useMemo(() => {
    const match = customTemplateId?.match(/-(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }, [customTemplateId]);

  const articleStyleData = useMemo(() => {
    if (!storyContent) return {};
    const item = storyContent?.find(c => c.moduleTitle === "article--styles");
    try {
      return item ? JSON.parse(item.json) : {};
    } catch {
      return {};
    }
  }, [storyContent]);

  const articleStatus = useMemo(() => {
    if (!storyContent) return {};
    const item = storyContent?.find(c => c.moduleTitle === "article--status");
    try {
      return item ? JSON.parse(item.json) : {};
    } catch {
      return {};
    }
  }, [storyContent]);

  const sectionContent = useMemo(() => {
    if (!storyContent) return [];
    const contentItems =
      storyContent?.map(contentItem => {
        const key = contentItem.key || contentItem.id;
        const content = contentItem.content || [];
        return { key, content };
      }) || [];

    return [
      {
        key: "article--data",
        id,
        colors: articleStyleData || {},
        showNavigation: articleStatus.showNavigation ?? false,
        showNextArticle: articleStatus.showNextArticle ?? false,
        showCTA: articleStatus.showCTA ?? false,
      },
      ...contentItems,
    ];
  }, [storyContent, id, articleStyleData, articleStatus]);

  console.log("storyUpdated  27/06");

  const handleLoaded = useCallback(val => {
    setIsLoaded(prev => (prev !== val ? val : prev));
  }, []);

  return (
    <>
      <GlobalStyle />
      {storyContent && (
        <IndexWrapper>
          <Loader content={sectionContent} handleLoaded={handleLoaded} />
          <LandingNavigation content={sectionContent} />
          <Section datoContentData={sectionContent} isLoaded={isLoaded} />
          <MemoizedThreeJsComponent datoContentData={sectionContent} />
        </IndexWrapper>
      )}
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query StoryQuery {
    allDatoCmsBespokeStory(
      filter: { id: { eq: "DatoCmsBespokeStory-aEniw5jaS16B4azvvCKc1w-en" } }
    ) {
      edges {
        node {
          id
          title
          customTemplateId
          heroImage {
            fluid {
              src
              srcSet
              aspectRatio
            }
          }
          content {
            ...DatoAgeGateFragment
            ...DatoArticleAggregatorFragment
            ...DatoCreditFragment
            ...DatoCtaFragment
            ...DatoCustomMarkupFragment
            ...DatoGalleryFragment
            ...DatoHeadlineFragment
            ...DatoHeroFragment
            ...DatoImageFragment
            ...DatoImageTextFragment
            ...DatoInterviewFragment
            ...DatoJsonInputFragment
            ...DatoLayoutDividerFragment
            ...DatoLoaderFragment
            ...DatoMarqueeFragment
            ...DatoParagraphFragment
            ...DatoProgressBarFragment
            ...DatoQuoteFragment
            ...DatoSeparatorFragment
            ...DatoShoppingCarouselFragment
            ...DatoSvgFragment
            ...DatoVideoFragment
            ...DatoVideoMuxFragment
            ...DatoKeyValuePairFragment
          }
        }
      }
    }
  }
`;
